"use client";

import { api } from "@/lib/api-client";
import type { DetailedListing } from "@/lib/types";
import { type PropsWithChildren, useEffect, useState } from "react";
import { listingAnalyticsContext } from "@/hooks/use-listing-analytics";

export function ListingAnalyticsProvider({
  children,
  listing,
}: PropsWithChildren<{ listing: DetailedListing }>) {
  const [trackedView, setTrackedView] = useState(false);

  const createAnalyticsEventMutation =
    api.listings.analytics.create.useMutation();

  async function trackView() {
    if (trackedView) {
      return;
    }

    setTrackedView(true);

    await createAnalyticsEventMutation.mutateAsync({
      id: listing.id,
      type: "VIEW",
    });
  }

  async function trackShare() {
    await createAnalyticsEventMutation.mutateAsync({
      id: listing.id,
      type: "SHARE",
    });
  }

  async function trackContactClick() {
    await createAnalyticsEventMutation.mutateAsync({
      id: listing.id,
      type: "CONTACT_CLICK",
    });
  }

  useEffect(() => {
    trackView();
  }, [listing]);

  return (
    <listingAnalyticsContext.Provider value={{ trackShare, trackContactClick }}>
      {children}
    </listingAnalyticsContext.Provider>
  );
}
